'use client';

import { isFilled, LinkField } from '@prismicio/client';

import {
  Link as OxygenLink,
  LinkProps as OxygenLinkProps,
} from '@preventx/oxygen';
import {
  appendSearchParams,
  useRetainableSearchParamsContext,
} from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

type LinkProps = {
  href: string | LinkField;
  retainSearchParams: boolean;
} & Omit<OxygenLinkProps, 'href'>;

/** **Purpose**     :   Due to the way Links work with the Referrer logic, this component will act as a wrapper
 *                  to the Oxygen Link version */
export const Link = ({
  as,
  id,
  rel,
  href,
  size,
  type,
  icon,
  target,
  colour,
  tooltip,
  variant,
  onClick,
  addBlock,
  children,
  prefetch,
  className,
  addSubtle,
  addHeadlineAction,
  retainSearchParams,
}: LinkProps) => {
  const { searchParams } = useRetainableSearchParamsContext();

  if (typeof href !== 'string' && !isFilled.link(href)) {
    return <>{children}</>;
  }

  const { WebsiteUrl } = applicationEnv();

  const path = appendSearchParams({
    link: href,
    as: 'default',
    searchParams: searchParams,
    applicationUrl: WebsiteUrl,
    retainSearchParams: retainSearchParams,
  });

  return (
    <OxygenLink
      as={as}
      id={id}
      rel={rel}
      href={path}
      size={size}
      type={type}
      icon={icon}
      target={target}
      colour={colour}
      tooltip={tooltip}
      variant={variant}
      onClick={onClick}
      addBlock={addBlock}
      prefetch={prefetch}
      className={className}
      addSubtle={addSubtle}
      addHeadlineAction={addHeadlineAction}
    >
      {children}
    </OxygenLink>
  );
};
